import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

import { ThemeProvider } from './utils/ThemeContext';

// Автоматическая перезагрузка при обновлении сборки на сервере (ошибки старых чанков)
const handleChunkError = (err) => {
  const isChunkError =
    err?.name === 'ChunkLoadError' ||
    /Loading chunk [\d\w]+ failed/i.test(err?.message || '') ||
    /Failed to fetch dynamically imported module/i.test(err?.message || '');

  if (isChunkError) {
    const lastReload = sessionStorage.getItem('last_chunk_reload');
    const now = Date.now();
    if (!lastReload || now - Number(lastReload) > 10000) {
      sessionStorage.setItem('last_chunk_reload', String(now));
      window.location.reload();
    }
  }
};

window.addEventListener('error', (event) => handleChunkError(event?.error));
window.addEventListener('unhandledrejection', (event) => handleChunkError(event?.reason));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
